export default __webpack_public_path__ + "static/media/103.3852d5b5.png";